import React, { useState } from "react";
import TradeCaseEditor from "../components/search/TradeCaseEditor";
import { getResourceAPI, postResource } from "../redux/slices/resourceSlice";
import { toCustomDate } from "../utils/date";
import { useDispatch, useSelector } from "react-redux";
import { getUIData, setUIProperty } from "../redux/slices/uiSlice";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react";
import { getUserId } from "../redux/slices/userSlice";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { tabNames } from "../utils/strings";

const formatData = (data) => {
  return {
    ...data,
    date: data.date || toCustomDate(),
  };
};

const NewCasePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userID = useSelector((state) => getUserId(state));
  const data = useSelector((state) => getUIData(state, "tradeCase:new"));
  const [pending, setPending] = useState(false);

  const handleClear = () =>
    dispatch(
      setUIProperty({
        name: "tradeCase:new",
        value: { state: "OPEN", employee_name: userID },
      })
    );

  const handlePost = () => {
    setPending(true);

    dispatch(
      postResource({
        path: "trade-case",
        data: formatData(data),
      })
    ).then(({ payload }) => {
      if (payload.error) {
        notify(payload.error, "error", 1000);
        setPending(false);

        return;
      }

      const { id } = payload.data;
      handleClear();
      notify(`Successfully created tradecase id:${id}`, "info", 3000);

      dispatch(
        getResourceAPI({
          path: "search",
          query: { our_ref: id },
        })
      ).then(() => {
        setPending(false);

        return history.push(`/admin/results/${tabNames[0]}`);
      });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h1 align="center"> Create Trade Case</h1>
      <TradeCaseEditor pending={pending} reduxName="tradeCase:new" />
      <div>
        <Grid
          container
          style={{ marginTop: "16px" }}
          align="center"
          justifyContent="center"
          spacing={5}
        >
          <Grid item xs={6}>
            <Button
              icon="clear"
              type="normal"
              text="Clear"
              hint="Clear Form"
              width="200"
              onClick={handleClear}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              icon="check"
              type="success"
              text="Confirm"
              hint="Create tradecase"
              width="200"
              onClick={handlePost}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default NewCasePage;
